import {
  HardDrive, FileText, FileSpreadsheet, Presentation, Cloud, BookOpen,
  Package, PenTool, Github, Youtube, Link2,
} from 'lucide-react';

/**
 * Lightweight provider detection for external document links. Maps a URL to a
 * friendly label, a semantic lucide icon, and a tint class so a long list of
 * links stays scannable at a glance. Pure client-side — no network calls.
 */
const PROVIDERS = [
  { key: 'gdocs', test: (h, p) => h.includes('docs.google.com') && p.includes('/document'), label: 'Google Docs', Icon: FileText, className: 'text-[#4285F4]' },
  { key: 'gsheets', test: (h, p) => h.includes('docs.google.com') && p.includes('/spreadsheets'), label: 'Google Sheets', Icon: FileSpreadsheet, className: 'text-[#0F9D58]' },
  { key: 'gslides', test: (h, p) => h.includes('docs.google.com') && p.includes('/presentation'), label: 'Google Slides', Icon: Presentation, className: 'text-[#F4B400]' },
  { key: 'gdrive', test: (h) => h.includes('drive.google.com') || h.includes('docs.google.com'), label: 'Google Drive', Icon: HardDrive, className: 'text-[#1a73e8]' },
  { key: 'sharepoint', test: (h) => h.includes('sharepoint.com'), label: 'SharePoint', Icon: Cloud, className: 'text-[#038387]' },
  { key: 'onedrive', test: (h) => h.includes('onedrive.') || h.includes('1drv.ms'), label: 'OneDrive', Icon: Cloud, className: 'text-[#0364B8]' },
  { key: 'confluence', test: (h, p) => h.includes('atlassian.net') || h.includes('confluence') || p.includes('/wiki'), label: 'Confluence', Icon: BookOpen, className: 'text-[#2684FF]' },
  { key: 'notion', test: (h) => h.includes('notion.so') || h.includes('notion.site'), label: 'Notion', Icon: FileText, className: 'text-[#0F2040]' },
  { key: 'dropbox', test: (h) => h.includes('dropbox.com'), label: 'Dropbox', Icon: Package, className: 'text-[#0061FF]' },
  { key: 'box', test: (h) => h === 'box.com' || h.endsWith('.box.com'), label: 'Box', Icon: Package, className: 'text-[#0061D5]' },
  { key: 'figma', test: (h) => h.includes('figma.com'), label: 'Figma', Icon: PenTool, className: 'text-[#A259FF]' },
  { key: 'github', test: (h) => h.includes('github.com'), label: 'GitHub', Icon: Github, className: 'text-[#0F2040]' },
  { key: 'youtube', test: (h) => h.includes('youtube.com') || h.includes('youtu.be'), label: 'YouTube', Icon: Youtube, className: 'text-[#FF0000]' },
];

export function detectLinkProvider(url) {
  let hostname = '';
  let pathname = '';
  try {
    const u = new URL(url);
    hostname = u.hostname.replace(/^www\./, '').toLowerCase();
    pathname = u.pathname.toLowerCase();
  } catch {
    return { key: 'link', label: url, Icon: Link2, className: 'text-[#4ABFCF]' };
  }
  const match = PROVIDERS.find((p) => p.test(hostname, pathname));
  if (match) return match;
  return { key: 'link', label: hostname || url, Icon: Link2, className: 'text-[#4ABFCF]' };
}

export default detectLinkProvider;
